export enum EVENT_KEYS {
  ENTER = 'Enter',
  ESCAPE = 'Escape',
}
